import React, { useEffect, useRef, useState } from "react";
import { TextField, TextFieldProps } from "@mui/material";

type Props = Omit<TextFieldProps, "type" | "value" | "defaultValue" | "onChange"> & {
  value: number | undefined;
  onChange: (value: number) => void;
};

export default function BillingNumberField({ value, onChange, inputProps, required = true, ...props }: Props) {
  const [draft, setDraft] = useState(value === undefined ? "" : String(value));
  const emitted = useRef(value);
  useEffect(() => {
    if (value !== emitted.current) {
      emitted.current = value;
      setDraft(value === undefined ? "" : String(value));
    }
  }, [value]);

  return <TextField {...props} type="number" value={draft} inputProps={{ ...inputProps, required }} onChange={event => {
    const text = event.target.value;
    setDraft(text);
    if (text !== "" && Number.isFinite(Number(text))) {
      emitted.current = Number(text);
      onChange(emitted.current);
    }
  }} />;
}
